import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";

export default function Verify() {
  const router = useRouter();

  useEffect(() => {
    const code = router.query.code;
    console.log(code);
    if (code) {
      Cookies.set("Refferal Token", code as string);
    }
    router.push("/accounts/sign-up");
  }, [router.query]);

  return <div className="h-screen"></div>;
}
